exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".svgIconComponent---2bpZU {\n  display: inline;\n  pointer-events: none; }\n", ""]);

// exports
exports.locals = {
	"svgIconComponent": "svgIconComponent---2bpZU"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/svg-icon/svg-icon.scss
// module id = 1197
// module chunks = 3